import { z } from 'zod';

export const BankImportStatusSchema = z.enum([
  'imported',
  'ignored',
  'possible_match',
  'recurring_price_change',
  'ready',
  'needs_category',
]);

export const RecurringPriceChangeSchema = z.object({
  recurring_expense_id: z.string(),
  rule_description: z.string(),
  occurrence_date: z.string(),
  expense_id: z.string(),
  expected_amount: z.number(),
  actual_amount: z.number(),
  matched_by: z.enum(['lineage', 'amount_band']),
});
export type RecurringPriceChange = z.infer<typeof RecurringPriceChangeSchema>;

export const ExpenseMatchCandidateSchema = z.object({
  id: z.string(),
  description: z.string(),
  amount: z.number(),
  currency_code: z.string(),
  date: z.string(),
});

export const ReconciledBankImportRowSchema = z.object({
  client_row_id: z.string(),
  bank_import_row_id: z.string(),
  status: BankImportStatusSchema,
  suggested_category_id: z.string().nullable().optional(),
  suggested_description: z.string().nullable().optional(),
  linked_expense: ExpenseMatchCandidateSchema.nullable().optional(),
  exact_match: ExpenseMatchCandidateSchema.nullable().optional(),
  possible_matches: z.array(ExpenseMatchCandidateSchema),
  recurring_price_change: RecurringPriceChangeSchema.nullable().optional(),
});

export const ReconcileBankImportResponseSchema = z.object({
  rows: z.array(ReconciledBankImportRowSchema),
});

export const ImportBankRowsResponseSchema = z.object({
  imported: z.array(z.object({
    bank_import_row_id: z.string(),
    expense_id: z.string(),
    status: z.literal('imported'),
  })),
  failed: z.array(z.object({
    bank_import_row_id: z.string(),
    message: z.string(),
  })),
});

export const IgnoreBankRowsResponseSchema = z.object({
  ignored: z.array(z.string()).optional(),
  unignored: z.array(z.string()).optional(),
});

export const LinkExistingBankRowResponseSchema = z.object({
  bank_import_row_id: z.string(),
  expense_id: z.string().nullable(),
  status: z.literal('imported'),
});

export type BankImportStatus = z.infer<typeof BankImportStatusSchema>;
export type ExpenseMatchCandidate = z.infer<typeof ExpenseMatchCandidateSchema>;
export type ReconciledBankImportRow = z.infer<typeof ReconciledBankImportRowSchema>;
export type ReconcileBankImportResponse = z.infer<typeof ReconcileBankImportResponseSchema>;
export type ImportBankRowsResponse = z.infer<typeof ImportBankRowsResponseSchema>;
